import {AbstractControl, ValidationErrors, Validators} from '@angular/forms';

export const USER_VALIDATORS = {
  MAIL: [
    Validators.required,
    Validators.email,
    Validators.minLength(3),
    Validators.maxLength(255),
  ],
  PASSWORD: [
    Validators.required,
    Validators.minLength(5),
    Validators.maxLength(50),
  ],
  SURNAME: [
    Validators.minLength(2),
    Validators.maxLength(255),
  ],
  NAME: [
    Validators.required,
    Validators.minLength(2),
    Validators.maxLength(255),
  ],
  PATRONYMIC: [
    Validators.minLength(2),
    Validators.maxLength(255),
  ],
};

export const TEST_VALIDATORS = {
  NAME: [
    Validators.required,
    Validators.minLength(3),
    Validators.maxLength(255),
  ],
  DESCRIPTION: [
    Validators.maxLength(4096),
  ]
};

export const TEST_EXECUTION_VALIDATORS = {
  STUDENT_NAME: [
    Validators.required,
    Validators.minLength(2),
    Validators.maxLength(255),
  ],
  STUDENT_MAIL: [
    Validators.required,
    Validators.email,
    Validators.minLength(4),
    Validators.maxLength(255),
  ],
};

export const QUESTION_VALIDATORS = {
  TYPE: [Validators.required],
  TEXT: [
    Validators.required,
    Validators.minLength(3),
    Validators.maxLength(2000),
  ],
  POSITION: [Validators.required],
  MIN_ANSWERS: [Validators.min(0)],
  MAX_ANSWERS: [Validators.min(0)],
  MIN_MAX_RANGE: (minControlName: string, maxControlName: string) => {
    return (control: AbstractControl): ValidationErrors | null => {
      const minControl = control.get(minControlName);
      const maxControl = control.get(maxControlName);

      if (!minControl || !maxControl) {
        return null;
      }

      const minValue = normalizeNumber(minControl.value);
      const maxValue = normalizeNumber(maxControl.value);

      if (minValue !== undefined && maxValue !== undefined && minValue > maxValue) {
        setControlError(maxControl, 'minGreaterThanMax', true);
        return {minGreaterThanMax: true};
      }

      setControlError(maxControl, 'minGreaterThanMax', false);
      return null;
    };
  },
};

export const ANSWER_OPTION_VALIDATORS = {
  TEXT: [
    Validators.required,
    Validators.minLength(1),
    Validators.maxLength(1000),
  ],
};

export const ANSWER_TEXT_VALIDATORS = {
  TEXT: [
    Validators.maxLength(2000),
  ],
};

export const TEST_LINK_VALIDATORS = {
  NAME: [
    Validators.required,
    Validators.minLength(3),
    Validators.maxLength(255),
  ],
  MAIL: [
    Validators.email,
    Validators.minLength(3),
    Validators.maxLength(255),
  ] || [
    Validators.pattern("^$")
  ],
  START_DATE: [Validators.required],
  FINISH_DATE: [Validators.required],
};

export const ANSWERED_TEXT_VALIDATORS = {
  TEXT: [
    Validators.required,
    Validators.maxLength(2000),
  ],
};

export const QUESTION_RESULT_VALIDATORS = {
  IS_CORRECT: [Validators.required],
};

const normalizeNumber = (value: any): number | undefined => {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }

  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isNaN(parsed) ? undefined : parsed;
};

const setControlError = (control: AbstractControl, errorKey: string, hasError: boolean): void => {
  const errors = control.errors || {};

  if (hasError) {
    errors[errorKey] = true;
    control.setErrors(errors);
  } else if (errors[errorKey]) {
    delete errors[errorKey];
    const hasOtherErrors = Object.keys(errors).length > 0;
    control.setErrors(hasOtherErrors ? errors : null);
  }
};
